import React from 'react';
import { Tooltip } from '@material-tailwind/react';
import Image from 'next/image';
import { useRouter } from 'next/router';
import { numberSeparator } from '@/utils/numberSeparator';

const ItemBoxAsset = (props: { url: string; name: string; image: string }) => {
  const router = useRouter();
  const { url, image, name } = props;
  return (
    <Tooltip content={numberSeparator(name)} placeholder='' onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
      <div
        className={`lg:col-span-4 md:col-span-3 col-span-3 ${url !== null && 'cursor-pointer'}`}
        onClick={() => {
          if (url !== null) {
            router.push(url);
          }
        }}
      >
        <div>
          <Image src={image} width={50} height={50} layout='responsive' className='rounded-[4px]' alt='blueprint' />
        </div>
      </div>
    </Tooltip>
  );
};

export default ItemBoxAsset;
